import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AlarmGroup } from "../../types/apiv1";
import { changeOrganization } from "./session";

export enum RejectionReason {
	Network,
	Bug,
};

export type AlarmGroupStateInitializing = {
	kind: 'initializing',
	pending:  boolean,
	rejectionReason?: RejectionReason,
};

export type AlarmGroupStateReady = {
	kind: 'ready',
	alarmGroups: AlarmGroup[],
};

export type AlarmGroupState = AlarmGroupStateInitializing | AlarmGroupStateReady;

const initialState = {
	kind: 'initializing',
} as AlarmGroupState;

export const alarmGroupSlice = createSlice({
	name: 'alarmGroup',
	initialState,
	reducers: {
		reset: (state, action: PayloadAction<RejectionReason | undefined>): AlarmGroupState => {
			return {
				kind: 'initializing',
				pending: false,
				rejectionReason: action.payload,
			};
		},
		pending: (state): AlarmGroupState => {
			return {
				kind: 'initializing',
				pending: true,
			}
		},
		ready: (state, action: PayloadAction<AlarmGroup[]>): AlarmGroupState => {
			return {
				kind: 'ready',
				alarmGroups: action.payload,
			};
		},
	},
	extraReducers: (builder) => {
		builder.addCase(changeOrganization, (): AlarmGroupState => {
			return {
				kind: 'initializing',
				pending: false,
			};
		})
	}
});

export const { reset, pending, ready } = alarmGroupSlice.actions;
export default alarmGroupSlice.reducer;
